export default "__VITE_ASSET__BNSg9OwR__"